import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  Row,
  Card,
  Button,
  Form,
  Badge,
} from "@themesberg/react-bootstrap";
import { inject, observer } from "mobx-react";
import Select from "../../ui/Dropdown";
import millify from "millify";
import { useLocation } from "react-router-dom";
import RequestExtraData from "../common/RequestExtraData";
export default inject("zigna_aiStore")(
  observer(
    ({
      zigna_aiStore,
      filterSet,
      filterSet1,
      setFilterSet,
      setError,
      selectedPayor,
      emcodes,
      setLargeData,
      includeCMS,
      setIncludeCMS,
    }) => {
      let location = useLocation();

      const [selectedProvider, setSelectedProvider] = useState(null);

      // const [filterSet,setFilterSet]=useState([])

      const updateFilterSet = (field, value, remove) => {
        // zigna_aiStore?.resetProviderExtractChartResult();

        let index = filterSet.findIndex((i) => i.field == field);
        let updatedFilerset = [];
        if (index > -1) {
          updatedFilerset = [...filterSet.slice(0, index)];
        } else {
          updatedFilerset = [...filterSet];
        }
        if (value?.name?.length || value?.length)
          return [...updatedFilerset, { field, value }].filter(
            (i) => !remove.find((j) => j == i.field)
          );
        else
          return [...updatedFilerset].filter(
            (i) => !remove.find((j) => j == i.field)
          );
      };
      // useEffect(() => {
      //   refetchFilterData([]);
      // }, [location]);
      console.log(filterSet, "all filterset");
      console.log({ filterSet1 });
      useEffect(() => {
        zigna_aiStore.professionalRateChoiceData = [];
        zigna_aiStore.professionalRateChoiceCount = 0;
      }, [filterSet]);

      const refetchFilterData = (filters) => {
        zigna_aiStore.getProfessionalOptionalFilters({
          filters: filters.map((i) => {
            return {
              field: i.field,
              value:
                i.field != "billing_code"
                  ? [i.value.name]
                  : ["most_frequent_rate","multiple_rates_reported","rate_type"].includes(i.field)
                  ? i.value.value
                  : i.value?.map((j) => j.name),
            };
          }),
        });
      };

      const onSubmitForm = () => {
        console.log({ filterSet });
        if (filterSet.length == 0) {
          setError(true);
          return;
        }
        setLargeData(false);
        zigna_aiStore
          .getRateInsightData({
            fields: [
              ...filterSet,
              // ...filterSet1,
              {
                field: `reporting_entity_name`,
                value: [{ name: selectedPayor }],
              },
            ].map((i) => {
              console.log(i);
              return {
                field: i.field,
                value:
                  i.field == "billing_code_range"
                    ? i.value?.value
                    : ["most_frequent_rate","multiple_rates_reported","rate_type"].includes(i.field)
                    ? i.value?.value
                    : i.value?.map((j) => j.name),
              };
            }),
          })
          .then((res) => {
            if (res.isLargeData == true) {
              setLargeData(true);
            }
          });
      };

      const handleDownload = (fields) => {
        zigna_aiStore.placeRateInsightsRequest(
          {
            fields: [
              ...filterSet1,
              {
                field: `reporting_entity_name`,
                value: [{ name: selectedPayor }],
              },
            ].map((i) => {
              console.log(i);
              return {
                field: i.field,
                value:
                  i.field == "billing_code_range"
                    ? i.value?.value
                    : ["most_frequent_rate","multiple_rates_reported","rate_type"].includes(i.field)
                    ? i.value?.value
                    : i.value?.map((j) => j.name),
              };
            }),
            downoadFile: true,
            request_type: "rate_insights",
            ...fields,
          },
          zigna_aiStore.setNotification
        );
      };
      const billingCodeGroups = {
        Anes: "Anes",
        Surg: "Surg",
        Rad: "Rad",
        "Path/Lab": "Path",
        Med: "Med",
        "E&M": "E&M",
      };
      const billingCodeGroupLabels = {
        Anes: "Anes (00001-09999)",
        Surg: "Surg (10000-69999)",
        Rad: "Rad (70000-79999)",
        "Path/Lab": "Path/Lab (80000-89999 )",
        Med: "Med (90000-99199,99500-99999)",
        "E&M": "E&M (99200-99499)",
      };
      const billingCodeGroupings = useMemo(() => {
        //if (!zigna_aiStore.professionalOptionalFilter?.billing_code) return [];
        return Object.keys(billingCodeGroups).map((groupName, index) => {
          return {
            id: index,
            // name: `${groupName} (${billingCodeGroups[groupName].map(range=>`${range[0]}-${range[1]}`).join(",")})`,
            name: billingCodeGroupLabels[groupName],
            value: billingCodeGroups[groupName],
          };
        });
      }, []);

      return (
        <Card border="light" className="shadow-sm filterSection">
          <Card.Body className="p-2">
            {/* <h5>Filter </h5> */}
            <Row>
              <Col className=" col-auto col-auto">
                <div className="mb-3">
                  <label className="form-label">Billing Code Grouping</label>
                  <div className="d-flex align-items-center h45 NPI-select">
                    {console.log(billingCodeGroupings)}
                    <Select
                      disabled={!selectedProvider}
                      className={`select-menu`}
                      value={
                        filterSet.find((i) => i.field == "billing_code_range")
                          ?.value || null
                      }
                      onChange={(e, data) => {
                        setFilterSet(
                          updateFilterSet("billing_code_range", e, [
                            "billing_code",
                          ])
                        );
                        // setFilterSet(updateFilterSet("billing_code", null));
                        //refetchFilterData(updateFilterSet("billing_code",e))
                      }}
                      // onMenuClose={() => refetchFilterData(filterSet)}
                      getOptionLabel={(option) => `${option.name}`}
                      options={billingCodeGroupings}
                      // allowSelectAll={true}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                    />
                  </div>
                </div>
              </Col>

              <Col className=" col-auto col-auto">
                <div className="mb-3">
                  <label className="form-label">Billing Code</label>
                  <div className="d-flex align-items-center h45 NPI-select">
                    <Select
                      disabled={!selectedProvider}
                      className={`select-menu`}
                      value={
                        filterSet.find((i) => i.field == "billing_code")
                          ?.value || null
                      }
                      onChange={(e, data) => {
                        setFilterSet(
                          updateFilterSet("billing_code", e, [
                            "billing_code_range",
                          ])
                        );
                        // setFilterSet(
                        //   updateFilterSet("billing_code_range", null)
                        // );
                        //refetchFilterData(updateFilterSet("billing_code",e))
                      }}
                      // onMenuClose={() => refetchFilterData(filterSet)}
                      getOptionLabel={(option) => `${option.name}`}
                      options={
                        zigna_aiStore.professionalFilterMaster
                          ?.billing_code || []
                      }
                      isMulti
                      allowSelectAll={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                    />
                  </div>
                </div>
              </Col>
              <Col className="d-flex align-items-center col-auto">
                <label className="d-flex align-items-center">
                  <input
                    style={{ width: "18px", height: "18px" }}
                    type="checkbox"
                    checked={includeCMS}
                    onChange={(e) => {
                      setIncludeCMS(e.target.checked ? true : false);
                    }}
                  ></input>
                  <span className="p-2">Include CMS rate</span>
                </label>
              </Col>
              <Col className=" col-auto">
                <label className="form-label">{"   "}</label>
                <div className="d-flex align-item-center">
                  <Button
                    // disabled={
                    //   !filterSet.find((i) => i.field == "billing_code")?.value
                    // }
                    //    disabled={

                    // 	!selectedProvider
                    //    }
                    variant="primary"
                    size="sm"
                    className="submitFilter"
                    onClick={(e) => {
                      onSubmitForm();
                    }}
                    type="button"
                  >
                    Submit
                  </Button>
                </div>
              </Col>
              <Col className="col-auto d-flex flex-grow-1 justify-content-end justify-items-end align-items-center">
                <RequestExtraData
                  withAlert={false}
                  message={""}
                  onConfirm={handleDownload}
                >
                  <span className="downloadBtn ">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 123 121"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_4_39)">
                        <path
                          d="M84.58 47C85.2961 46.2624 86.1525 45.6755 87.0988 45.2737C88.0451 44.872 89.0621 44.6635 90.0902 44.6607C91.1182 44.6578 92.1364 44.8605 93.0849 45.257C94.0335 45.6534 94.8931 46.2355 95.6133 46.9691C96.3336 47.7026 96.8998 48.5728 97.2788 49.5285C97.6578 50.4841 97.8418 51.5059 97.82 52.5337C97.7983 53.5615 97.5712 54.5746 97.1522 55.5133C96.7332 56.4521 96.1306 57.2975 95.38 58L66.09 86.88C64.6464 88.2981 62.7036 89.0927 60.68 89.0927C58.6564 89.0927 56.7136 88.2981 55.27 86.88L26.4 58.37C24.9413 56.9365 24.1118 54.9823 24.094 52.9372C24.0762 50.8921 24.8715 48.9237 26.305 47.465C27.7385 46.0063 29.6927 45.1768 31.7378 45.159C33.7829 45.1412 35.7513 45.9365 37.21 47.37L53.1 63.12L53.26 7.65C53.3468 5.65118 54.2063 3.76414 55.6572 2.38657C57.1081 1.009 59.0371 0.248502 61.0378 0.265358C63.0384 0.282213 64.9544 1.0751 66.3818 2.47692C67.8093 3.87874 68.6369 5.78 68.69 7.78L68.54 62.78L84.58 47ZM0 113.48L0.1 83.3C0.0733066 82.2639 0.255513 81.233 0.635757 80.2689C1.016 79.3047 1.58649 78.427 2.31323 77.688C3.03996 76.9491 3.90804 76.364 4.86573 75.9677C5.82341 75.5715 6.85109 75.3721 7.88748 75.3815C8.92387 75.3909 9.94776 75.6089 10.8981 76.0225C11.8484 76.4361 12.7058 77.0368 13.419 77.7888C14.1322 78.5408 14.6866 79.4288 15.0493 80.3997C15.412 81.3706 15.5755 82.4046 15.53 83.44L15.46 105.44C46.1267 105.5 76.7633 105.5 107.37 105.44L107.44 83.32C107.459 81.2725 108.29 79.3163 109.751 77.8816C111.212 76.447 113.183 75.6514 115.23 75.67C117.277 75.6886 119.234 76.5197 120.668 77.9806C122.103 79.4415 122.899 81.4125 122.88 83.46L122.78 113.46H122.69C122.6 115.432 121.758 117.294 120.337 118.663C118.916 120.032 117.023 120.804 115.05 120.82C79.23 120.887 43.4367 120.887 7.67 120.82C5.69389 120.814 3.79555 120.049 2.36785 118.683C0.940148 117.317 0.0923821 115.454 0 113.48H0Z"
                          fill="#B54491"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_4_39">
                          <rect width="122.88" height="120.89" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="ml-5" onClick={() => {}}>
                      All Billing Codes
                    </span>
                  </span>
                </RequestExtraData>
              </Col>
              <Col className="col-12">
                <Badge bg="primary" className="px-2 py-2 mx-2">
                  Payor: {selectedPayor}
                </Badge>
                {filterSet.find((i) => i.field == "billing_code")?.value
                  ?.length ? (
                  filterSet
                    .find((i) => i.field == "billing_code")
                    ?.value.map((i) => {
                      return (
                        <Badge bg="primary" className="px-2 py-2 mx-2">
                          Code: {i.name}
                        </Badge>
                      );
                    })
                ) : filterSet.find((i) => i.field == "billing_code_range")
                    ?.value ? (
                  <Badge bg="primary" className="px-2 py-2 mx-2">
                    {
                      filterSet.find((i) => i.field == "billing_code_range")
                        ?.value?.name
                    }
                  </Badge>
                ) : (
                  <Badge bg="primary" className="px-2 py-2 mx-2">
                    E&amp;M: 99200-99499
                  </Badge>
                )}
              </Col>
              {/* <Col className="col-12">
							<div >

						
						<span className='text-danger'>*</span> &nbsp;- &nbsp;<small>Mandatory Filter</small> 
						</div>
						</Col> */}
            </Row>
            <Row></Row>
          </Card.Body>
        </Card>
      );
    }
  )
);
